import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import About from './components/About';
import Travel from './components/Travel';
import Reviews from './components/Reviews';
import Contact from './components/Contact';

function App() {
  return (
    <>
      <Router>
      <Navbar />
      <section id='/'>
        <Home />
      </section>

      <section id='about'>
        <About />
      </section>

      <section id="travel">
        <Travel />
      </section>

      <section id="test">
        <Reviews />
      </section>

      <section id="contact">
        <Contact />
      </section>
        <Footer />
      </Router>



    </>
  );
}

export default App;
